import React from 'react';
import Ports from '../../containers/Ports/Ports';

const PortsPage = () => {
  return <Ports />;
};

export default PortsPage;
